module.exports = __webpack_public_path__ + "static/mehandi-e1ae17248951eb7bc704c61c6a2d6b54.png";